import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_activities.svg';
import Icon, { IconProps } from './icon';

const IconActivities = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconActivities;
